{
  "actions": "Acțiuni"
}
